// Generated by `npm run bag` (scripts/bagLimits.ts) from data/mrip-hawaii/ (NOAA's Marine Recreational Information Program, its Hawaiʻi
// intercepts) and DAR's commercial figures. Do not edit by hand: change the script and run it. tests/bagLimits.test.ts builds it again
// and fails if this file is not what they give.

/**
 * The share of a fishing group's catch beyond a daily limit of N fish a fisher, N from 0 to 20 (the index), where no limit
 * bound it (M170, `scripts/bagLimits.ts`). Noncommercial: MEASURED, NOAA's intercepts in Hawaiʻi, each fisher's landed fish on
 * the days they landed one or more, weighted by the survey (uhu 405 fisher-days, kala 122, jacks 2542, moano kea 206).
 */
export const NONCOMMERCIAL_BEYOND = {
  uhu: [1, 0.3583, 0.1532, 0.0932, 0.0679, 0.0489, 0.0337, 0.0225, 0.0146, 0.0119, 0.0092, 0.0069, 0.0046, 0.004, 0.0035, 0.0029, 0.0023, 0.0017, 0.0012, 0.0006, 0],
  kala: [1, 0.4405, 0.1958, 0.0853, 0.037, 0.0173, 0.01, 0.0027, 0.0018, 0.0009, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  jacks: [1, 0.35, 0.143, 0.0801, 0.0494, 0.0316, 0.02, 0.0113, 0.0066, 0.0044, 0.0028, 0.0018, 0.0013, 0.0012, 0.0011, 0.001, 0.001, 0.0009, 0.0008, 0.0007, 0.0006],
  goatfish: [1, 0.269, 0.1163, 0.0632, 0.0394, 0.0292, 0.0207, 0.0134, 0.0085, 0.0037, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
} as const;

/**
 * The same for the commercial fishers, DERIVED: a negative binomial catch a trip fitted to DAR's two figures a group (its
 * catch from trips of two or fewer fish, and beyond two a fisher a day; the uhu's mean 7.251 and spread
 * 0.5483, the kala's 7.858 and 3.6586, before the truncation at none).
 */
export const COMMERCIAL_BEYOND = {
  uhu: [1, 0.8943, 0.8049, 0.7273, 0.6591, 0.5986, 0.5445, 0.4961, 0.4525, 0.4131, 0.3776, 0.3454, 0.3161, 0.2895, 0.2653, 0.2433, 0.2232, 0.2049, 0.1881, 0.1728, 0.1588],
  kala: [1, 0.8747, 0.7541, 0.6411, 0.538, 0.4459, 0.3655, 0.2966, 0.2383, 0.1899, 0.1502, 0.1179, 0.092, 0.0713, 0.055, 0.0422, 0.0322, 0.0245, 0.0185, 0.014, 0.0105],
} as const;

/** The moano kea's landed fish caught on a hook and line, MEASURED from NOAA's intercepts (M179, `lineShare`). */
export const GOATFISH_LINE_SHARE = 0.7277;
